import { Paper, Title } from '@yoast/ui-library';
import cx from 'classnames';

export default function PaperHeader({
  children,
  description,
  title,
}: {
  children?: React.ReactNode;
  description?: string | React.ReactNode;
  title?: string | React.ReactNode;
}) {
  return (
    <Paper.Header>
      {title && (
        <Title className={cx({ 'yst-mb-3': description || children })}>
          {title}
        </Title>
      )}
      {description &&
        (typeof description === 'string' ? <p>{description}</p> : description)}
      {children}
    </Paper.Header>
  );
}
